module.exports = __webpack_public_path__ + "img/image11@2x.89cdb17d.png";